import { PlayerRef } from '@remotion/player';
import createStore from '@/stores/store';

export const remotionPlayerStateStore = createStore({
  currentTime: 0
});

let pendingPlayerSeekFrameId: number | null = null;

function cancelPendingPlayerSeek() {
  if (pendingPlayerSeekFrameId !== null) {
    cancelAnimationFrame(pendingPlayerSeekFrameId);
    pendingPlayerSeekFrameId = null;
  }
}

export function setCurrentTime(currentTime: number, fps: number, remotionPlayerRef: PlayerRef) {
  cancelPendingPlayerSeek();
  remotionPlayerRef.seekTo(Math.floor(currentTime * fps));
  remotionPlayerStateStore.set(state => ({
    ...state,
    currentTime
  }));
}

/**
 * Seeks to a time computed from clip data that was just updated.
 *
 * `PlayerRef.seekTo` clamps to the `durationInFrames` of the Player's last render, so seeking
 * synchronously after an edit that lengthens the clip (shrinking a delete, restoring) clamps
 * the frame near the recording end. The cue point moves immediately, and the Player seek runs
 * on the next animation frame, after React commits the new duration. This is a one-shot seek,
 * not an effect on the duration, so no render/seek feedback loop is created.
 */
export function setCurrentTimeAfterPlayerUpdate(currentTime: number, fps: number, remotionPlayerRef: PlayerRef) {
  cancelPendingPlayerSeek();
  remotionPlayerStateStore.set(state => ({
    ...state,
    currentTime
  }));
  pendingPlayerSeekFrameId = requestAnimationFrame(() => {
    pendingPlayerSeekFrameId = null;
    remotionPlayerRef.seekTo(Math.floor(currentTime * fps));
  });
}

export function setCurrentTimeWithoutSeeking(currentTime: number) {
  remotionPlayerStateStore.set(state => ({
    ...state,
    currentTime
  }));
}
